<template>
<div class="bb-dataAnalysis">
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name: 'DataAnalysis',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.bb-dataAnalysis {
    .summary{
        display: flex;
        .box{
            flex-grow: 1;
            height: 120px;
            padding: 30px;
            box-sizing: border-box;
            .name{
                margin-bottom: 16px;
            }
            .value{
                color: #409EFF;
                font-size: 24px;
            }
        }
        .box+.box{
            margin-left: 30px;
        }
    }
    .total {
        height: 420px;
        display: flex;
        justify-content: flex-start;
        background: #fff;
        margin-top: 30px;
        .left {
            padding: 0 10px;
            box-sizing: border-box;
            background: #fff;
            width: 240px;
            min-width: 240px;
            max-width: 240px;
            height: 100%;
            border-right: 1px solid #DCDFE6 ;
            .outbox {
                height:100%;
                box-sizing: border-box;
                .innerbox{
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    height: 100%;
                    .box{
                        flex-grow: 1;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .name{
                            font-size: 12px;
                            margin-bottom: 10px;
                            display: flex;
                            align-items: center;
                            margin-bottom: 16px;
                            .tip{
                                margin-left: 6px;
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                            }
                        }
                        .value{
                            font-size: 24px;
                        }
                    }
                    .box+.box{
                        border-top: 1px solid #DCDFE6 ;
                    }
                }
            }
            .outbox + .outbox {
                border-top: 1px solid $line;
            }
        }
        .right {
            flex-grow: 1;
            overflow: hidden;
            .filters {
                margin-bottom: 0 !important;
                border-bottom: 1px solid $line;
                padding: 20px 10px;
                .add .el-button {
                    min-width: 48px;
                    font-size: 12px;
                }
                .search .el-button {
                    min-width: 72px;
                    font-size: 12px;
                }
                .dateInput {
                    margin-right: 10px;
                    width: 240px;
                    height: 36px;
                }
                .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
                    cursor: pointer;
                }
                .el-date-editor .el-range-separator {
                    line-height: 28px;
                }
            }
            .echert {
                margin: 10px;
            }
            .lineDatas {
                background: $bgcolor-white;
            }
            .lineReport {
                flex-grow: 1;
            }
        }
    }
    .list {
        margin-top: 20px;
        .box{
            border-top: 1px solid $line;
            display: flex;
            overflow: hidden;
            .innerbox{
                width: 33.33%;
                text-align: center;
                height: 48px;
                line-height: 48px;
                box-sizing: border-box;
                overflow: hidden;
            }
        }
        .outbox{
            border-top: 2px solid $line;
        }
        .box:hover{
            background: #f5f7fa;
        }
        .tableData{
            border: 1px solid $line;
        }
        .lengdeList{
            background: #FAFAFA;
            border-top: 0px solid $line;
        }
    }
}
</style>
